import { useForm } from 'react-hook-form';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import Loader from 'react-loader-spinner';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { addCustomerRequestWithoutLogin } from '../store/api/Services';
import { checkNationalCode, check_phone, createCaptcha } from '../store/api/CommonFunctions';
import { BootstrapReboot } from 'react-bootstrap-icons';
const ServiceWithoutLogin = (props) => {
    const frm = useRef();
    const captchaCode = useRef("");
    const { setShowService } = props;
    const [captchaError, setCaptchaError] = useState(null);
    const [pending, setPending] = useState(false);
    const dispatch = useDispatch();
    const { register, handleSubmit, errors } = useForm();
    useEffect(() => {
        document.body.classList = "notMain";
        captchaCode.current = createCaptcha(document.getElementById("captcha"));
    }, []);
    function refreshCaptcha() {
        captchaCode.current = createCaptcha(document.getElementById("captcha"));
    }
    const onSubmit = (data) => {
        setCaptchaError(null);
        const txt = document.getElementById("cpatchaTextBox").value;
        if (txt?.toLowerCase() !== captchaCode.current) {
            refreshCaptcha();
            setCaptchaError("کد وارد شده صحیح نیست");
            return;
        }
        const onSuccess = () => {
            setPending(false);
            frm.current.reset();
            refreshCaptcha();
            //setShowService(false);
        }
        dispatch(addCustomerRequestWithoutLogin(data, onSuccess))
    }

    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle"> ثبت درخواست خدمات </div>
                <div className="card-body bodyStyle">
                    <form onSubmit={handleSubmit(onSubmit)} ref={frm}>
                        <Row>
                            <div className="form-group col-md-3">
                                <label> نوع درخواست </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <select className="form-control" name="RequestType" ref={register({ required: true })} >
                                    <option value=""> لطفا انتخاب کنید </option>
                                    <option value="repair"> درخواست تعمیر </option>
                                    <option value="install"> درخواست نصب </option>
                                </select>
                                {errors.ServiceType && <small className="errors"> نوع سرویس را وارد کنید </small>}
                            </div>
                            <Col md={3} className='form-group'>
                                <label> نام درخواست دهنده </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <Form.Control name="CustomerName" ref={register({ required: true })} />
                                {errors?.CustomerName && <small className='errors'>نام درخواست کننده را وارد کنید</small>}
                            </Col>
                            <Col md={3} className='form-group'>
                                <label> موبایل درخواست دهنده </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <Form.Control name="CustomerMobile" ref={register({ required: true, validate: check_phone })} />
                                {errors?.CustomerMobile && <small className='errors'>موبایل درخواست کننده وارد نشده/معتبر نیست</small>}
                            </Col>
                            <Col md={3} className='form-group'>
                                <label> شماره ملی درخواست دهنده </label>
                                <Form.Control name="CustomerNationalCode" ref={register({ validate: checkNationalCode })} />
                                {errors?.CustomerNationalCode && <small className='errors'>شماره ملی معتبر نیست</small>}
                            </Col>
                            <div className="form-group col-md-3" >
                                <label> شماره سریال </label>
                                <input className="form-control" name="ProductSerial" ref={register({})} type="text" />
                            </div>

                            <div className="form-group  col-md-3">
                                <label> آدرس محل مراجعه تکنسین </label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <input className="form-control" name="CustomerAddress" ref={register({ required: true })} type="text" />
                                {errors?.CustomerAddress && <small className="errors"> آدرس اجباری است </small>}
                            </div>
                        </Row>
                        <Col md={2} className='rowBorder mt-3' style={{ margin: "2px", padding:"8px" }}>
                            <div className='rowTitle'>
                                کد امنیتی <BootstrapReboot color='#bb1375' size={18} className='hoverIcon' onClick={refreshCaptcha} />
                            </div>
                            <div className='mt-1' id="captcha">
                            </div>

                            <Form.Control placeholder="کد امنیتی را وارد کنید" id="cpatchaTextBox" style={{direction:'ltr', fontFamily:"sans-serif"}}/>
                            {captchaError && <small className='errors'>{captchaError}</small>}
                        </Col>
                        {!pending &&
                            <Fragment>
                                <Button className="col-md-1 mt-2" type='submit' variant='info'>  ثبت درخواست  </Button>
                                <Button className='mt-2 col-md-1' variant='danger' style={{ marginRight: "3px" }} onClick={() => setShowService(false)}>انصراف</Button>
                            </Fragment>
                        }
                        {pending && <span> لطفا کمی صبر کنید <Loader type="BallTriangle" color="red" height={20} width={20} style={{ display: "inline-block" }} /> </span>}


                    </form>
                </div>
            </div>


        </div>
    )
}
export default ServiceWithoutLogin;
